module.exports = __webpack_public_path__ + "img/telegram-plane.d5ac4e56.svg";